import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined';
import ExploreIcon from '@mui/icons-material/Explore';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  allAvailableEventTypes,
  displayNamesOfEventTypes,
  SESSION_PLATFORM_ONLINE,
  SUBTYPE_POST_CONSULTATION,
  SUBTYPE_PRE_CONSULTATION,
  BOOKING_STATUSES,
  BOOKING_PAYMENT_STATUSES,
} from 'src/consumer/constants';
import { ProfileContext } from 'src/consumer/context/ProfileContext';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper';
import { getTabOrder } from 'src/consumer/helpers/tabDataHelper';
import {
  selectPatientInfoList,
  setPatientInfoList
} from 'src/consumer/reducers/personalData/personalDataReducer';
import { getDataWithParams } from 'src/consumer/services/profileService';
import {
  getImageLink,
  getInitialsForChat,
  isCommonResponseSuccessful,
  sleep,
} from 'src/mentor/helpers/utilityFunctions';
import {
  FlashingTokenNumber,
  PatientHomepageSectionContainer,
  PatientProfileChoosingContainer,
  PatientProfileItemContainer,
  PHHeading,
  PHJoinButtonContainer,
  PHMentorImage,
  PHStepStatus,
} from './styles';

dayjs.extend(utc)
dayjs.extend(timezone)

export const PatientHomepageWelcomeSection = ({ chosenPatientId, setChosenPatientId }) => {
  const dispatch = useDispatch()
  const patientInfoAndClinicBrandListFromStore = useSelector(selectPatientInfoList)
  const [profileChoosingScreenOpen, setProfileChoosingScreenOpen] = useState(false)
  const [localChosenPatientInfoData, setLocalChosenPatientInfoData] = useState()

  async function getDataFromServerSetInStore() {
    const response = await getDataWithParams(`/api/secure/patient-user/patient-info/list`)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      dispatch(setPatientInfoList(response?.data?.data || []))
    }
  }

  useEffect(() => {
    getDataFromServerSetInStore()
  }, [])

  useEffect(() => {
    if (
      Array.isArray(patientInfoAndClinicBrandListFromStore?.patientInfoList) &&
      patientInfoAndClinicBrandListFromStore?.patientInfoList?.length > 0
    ) {
      if (chosenPatientId) {
        const patientInfoData = (
          patientInfoAndClinicBrandListFromStore?.patientInfoList || []
        )?.find((item) => item?.id === chosenPatientId)
        if (patientInfoData) {
          setLocalChosenPatientInfoData(patientInfoData)
        } else {
          setChosenPatientId(patientInfoAndClinicBrandListFromStore?.patientInfoList?.[0]?.id)
          setLocalChosenPatientInfoData(
            patientInfoAndClinicBrandListFromStore?.patientInfoList?.[0],
          )
        }
      } else {
        setChosenPatientId(patientInfoAndClinicBrandListFromStore?.patientInfoList?.[0]?.id)
        setLocalChosenPatientInfoData(patientInfoAndClinicBrandListFromStore?.patientInfoList?.[0])
      }
    }
  }, [patientInfoAndClinicBrandListFromStore, chosenPatientId])

  console.log(localChosenPatientInfoData)

  return (
    <PatientHomepageSectionContainer>
      <PHHeading>Welcome {localChosenPatientInfoData?.name} !</PHHeading>
      <div>
        {localChosenPatientInfoData?.name},{' '}
        {getAgeFromDobWithTime(localChosenPatientInfoData?.dateOfBirth)},{' '}
        {getClinicBrandNameFromClinicBrandId(
          localChosenPatientInfoData?.clinicBrandId,
          patientInfoAndClinicBrandListFromStore?.clinicBrandList,
        )}
      </div>
      <div
        onClick={() => setProfileChoosingScreenOpen((prev) => !prev)}
        style={{ cursor: 'pointer' }}
      >
        <u>Switch Profile</u>
        {/* <SwitchAccountIcon /> */}
      </div>
      {profileChoosingScreenOpen && (
        <PatientProfileChoosingFullScreen
          patientInfoAndClinicBrandListFromStore={patientInfoAndClinicBrandListFromStore}
          setChosenPatientId={setChosenPatientId}
          closeFunction={() => setProfileChoosingScreenOpen(false)}
        />
      )}
    </PatientHomepageSectionContainer>
  )
}

const PatientProfileChoosingFullScreen = ({
  patientInfoAndClinicBrandListFromStore,
  closeFunction,
  setChosenPatientId,
}) => {
  const [faded, setFaded] = useState(false)
  const [selectedProfileId, setSelectedProfileId] = useState()

  async function handleChoosingPatientProfile(patientInfoId) {
    sessionStorage.setItem('chosenPatientProfile', patientInfoId)
    setSelectedProfileId(patientInfoId)
    setChosenPatientId(patientInfoId)
    await sleep(750) // waiting for animation of selected item going to center to complete
    setFaded(true)
    await sleep(250) // wait for fade animation to complete before removing
    closeFunction()
  }

  return (
    <PatientProfileChoosingContainer faded={faded}>
      {patientInfoAndClinicBrandListFromStore?.patientInfoList?.map(
        (patientInfoItem, patientInfoItemIndex) => {
          return (
            <div key={patientInfoItemIndex}>
              {(!Boolean(selectedProfileId) || selectedProfileId === patientInfoItem?.id) && (
                <PatientProfileItem
                  clickFunction={() => handleChoosingPatientProfile(patientInfoItem?.id)}
                  selected={selectedProfileId === patientInfoItem?.id}
                  patientInfoItem={patientInfoItem}
                  clinicBrandName={getClinicBrandNameFromClinicBrandId(
                    patientInfoItem?.clinicBrandId,
                    patientInfoAndClinicBrandListFromStore?.clinicBrandList,
                  )}
                />
              )}
            </div>
          )
        },
      )}
    </PatientProfileChoosingContainer>
  )
}

const PatientProfileItem = ({ clickFunction, selected, patientInfoItem, clinicBrandName }) => {
  const profileRef = useRef(null)
  const [startPosition, setStartPosition] = useState({
    startX: 0,
    startY: 0,
  })

  useEffect(() => {
    if (profileRef) {
      const rect = profileRef.current.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2
      setStartPosition({ centerX, centerY })
    }
  }, [])

  return (
    <PatientProfileItemContainer
      ref={profileRef}
      key={patientInfoItem?.id}
      centerX={startPosition?.centerX || 0}
      centerY={startPosition?.centerY || 0}
      selected={selected}
      onClick={() => {
        console.log(startPosition.startX)
        console.log(startPosition.startY)
        clickFunction()
      }}
    >
      <div
        style={{
          background: '#6874DC',
          color: '#fff',
          borderRadius: '50%',
          width: '150px',
          height: '150px',
          fontSize: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {getInitialsForChat(patientInfoItem?.name)}
      </div>
      <div>
        {patientInfoItem?.name}, {getAgeFromDobWithTime(patientInfoItem?.dateOfBirth)}
      </div>
      <div>({clinicBrandName})</div>
    </PatientProfileItemContainer>
  )
}

//
//
//
//
//
//
//

export const PatientHomepageTodaysBookingSection = ({ chosenPatientId }) => {
  const [patientTodayAgendaData, setPatientTodayAgendaData] = useState()
  const [loading, setLoading] = useState(false)

  const localTimezone = dayjs.tz.guess()
  const startTime = dayjs().tz(localTimezone).startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]')
  const endTime = dayjs().tz(localTimezone).endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]')

  async function getAndSetData() {
    setLoading(true)
    setPatientTodayAgendaData()
    if (!Boolean(chosenPatientId)) {
      return
    }
    const response = await getDataWithParams(`/api/secure/patient-user/agenda/list`, {
      startTime: startTime,
      endTime: endTime,
      patientId: chosenPatientId,
    })
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      setPatientTodayAgendaData(response?.data?.data?.agendaList || [])
    }
    setLoading(false)
  }

  useEffect(() => {
    getAndSetData()
  }, [chosenPatientId])

  if (!Boolean(chosenPatientId)) {
    return <></>
  }

  return (
    <PatientHomepageSectionContainer>
      <div>
        <PHHeading>Today&apos;s Agenda</PHHeading>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', margin: '16px 0', gap: '16px' }}>
        {patientTodayAgendaData?.length > 0 ? (
          patientTodayAgendaData?.map((agendaItem, agendaItemIndex) => {
            if (agendaItem?.type === 'clinic-visit') {
              return (
                <SingleVisitCard
                  key={agendaItemIndex}
                  clinicVisitData={agendaItem?.data?.clinicVisitData}
                />
              )
            } else if (agendaItem?.type === 'medicine') {
              return <></>
            } else {
              return <></>
            }
          })
        ) : (
          <div>
            {loading ? (
              <div>
                {' '}
                <Box sx={{ width: '100%' }}>
                  <LinearProgress color="secondary" />
                </Box>
              </div>
            ) : (
              <div>Nothing on Today&apos;s Agenda</div>
            )}
          </div>
        )}
      </div>
    </PatientHomepageSectionContainer>
  )
}

const SingleVisitCard = ({ clinicVisitData }) => {
  let clinicName = ''
  if (clinicVisitData?.clinicLocationId) {
    const foundClinicLoc = clinicVisitData?.clinicLocationList.find(
      (item) => item?.id === clinicVisitData?.clinicLocationId,
    )
    if (foundClinicLoc) {
      clinicName = foundClinicLoc?.name || ''
    }
  }
  return (
    <div style={{ background: '#fff', borderRadius: '8px', padding: '8px' }}>
      <div>
        <b>Clinic Visit - {clinicName}</b>
      </div>
      <div className="d-flex flex-column" style={{ margin: '16px 0', gap: '8px' }}>
        <div>
          {(clinicVisitData?.consultationBookedEvent?.previousSteps || []).map(
            (prevStep, prevStepIndex) => {
              const thisStepData = (clinicVisitData?.relatedBookedEvents || [])?.find(
                (item) => item?.id === prevStep?.refId,
              )
              return (
                <VisitStepCard
                  key={'ps' + prevStepIndex}
                  data={thisStepData}
                  clinicVisitData={clinicVisitData}
                />
              )
            },
          )}
        </div>
        <div>
          <VisitStepCard
            data={clinicVisitData?.consultationBookedEvent}
            clinicVisitData={clinicVisitData}
          />
        </div>
        <div>
          {(clinicVisitData?.consultationBookedEvent?.nextSteps || []).map(
            (nextStep, nextStepIndex) => {
              const thisStepData = (clinicVisitData?.relatedBookedEvents || [])?.find(
                (item) => item?.id === nextStep?.refId,
              )
              return (
                <VisitStepCard
                  key={'ns' + nextStepIndex}
                  data={thisStepData}
                  clinicVisitData={clinicVisitData}
                />
              )
            },
          )}
        </div>
      </div>
    </div>
  )
}

const VisitStepCard = ({ data, clinicVisitData }) => {
  const navigate = useNavigate()

  let title
  if (
    data?.eventType === allAvailableEventTypes.screening &&
    data?.eventSubType === SUBTYPE_PRE_CONSULTATION
  ) {
    title = 'Pre-Consultation Screening'
  } else if (
    data?.eventType === allAvailableEventTypes.screening &&
    data?.eventSubType === SUBTYPE_POST_CONSULTATION
  ) {
    title = 'Post-Consultation Screening'
  } else {
    title = displayNamesOfEventTypes?.[allAvailableEventTypes?.[data?.eventType]]
  }

  let statusText = 'Scheduled'
  let statusAccentBgColor = '#000'
  if (data?.status === 'booked' && data?.markedCompleted) {
    statusText = 'Completed'
    statusAccentBgColor = '#004D00'
  } else if (data?.status === 'booked') {
    statusText = 'Scheduled'
    statusAccentBgColor = '#000'
  } else if (data?.status === 'cancelled') {
    statusText = 'Cancelled'
    statusAccentBgColor = '#f00'
  }

  return (
    <div
      className="d-flex flex-column flex-md-row justify-content-between gap-4"
      style={{ border: '1px solid #cecece', borderRadius: '4px', padding: '4px', fontSize: '12px' }}
    >
      <div>
        <div style={{ fontSize: '16px' }}>
          {title} <span>w/ {data?.mentorName}</span>
        </div>
        <div>
          {data?.mentorProfilePic && (
            <PHMentorImage alt={`${data?.mentorName}`} src={getImageLink(data?.mentorProfilePic)} />
          )}
        </div>
        <div style={{ margin: '4px 0' }}>
          {!data?.markedCompleted && (
            <TokenNumberComponent data={data} clinicVisitData={clinicVisitData} />
          )}
        </div>
        {/* {Boolean(data?.feePaid) && (
          <div>
            Fee Paid: {currency_list?.find((item) => item.code === data?.currency)?.symbol}
            {data?.feePaid}
          </div>
        )} */}
      </div>
      <div className="d-flex flex-column gap-1 align-items-md-end">
        {/* Hide join button for blocked sessions (payment pending) */}
        {data?.meetingSrc === SESSION_PLATFORM_ONLINE && 
         !data?.markedCompleted && 
         !(data?.status === BOOKING_STATUSES.BOOKING_INITIATED && data?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING) && (
          <>
            <div>Starts: {dayjs.utc(data?.startTime).local().format('DD MMM YYYY HH:mmA')}</div>
            <PHJoinButtonContainer onClick={() => navigate(`/l/${data?.slug}`)}>
              <div>
                <VideocamOutlinedIcon style={{ fontSize: '24px' }} />
                <ArrowOutwardOutlinedIcon style={{ fontSize: '12px' }} />
              </div>
              <div>Join</div>
            </PHJoinButtonContainer>
          </>
        )}
        {/* Show blocked status for blocked sessions */}
        {data?.status === BOOKING_STATUSES.BOOKING_INITIATED && 
         data?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING && (
          <PHStepStatus accentBgColor="#fbbf24" accentColor="#78350f">
            Awaiting Payment
          </PHStepStatus>
        )}
        {data?.markedCompleted && data?.eventType === allAvailableEventTypes.consultation && (
          <PHJoinButtonContainer onClick={() => navigate(`/session/${data?.id}/prescription`)}>
            <div>
              <span style={{ fontSize: '20px' }}>Rx</span>
              <ArrowOutwardOutlinedIcon style={{ fontSize: '12px' }} />
            </div>
            <div>View</div>
            <div>Prescription</div>
          </PHJoinButtonContainer>
        )}
        <PHStepStatus accentBgColor={statusAccentBgColor} accentColor={'#fff'}>
          {statusText}
        </PHStepStatus>
      </div>
    </div>
  )
}

const TokenNumberComponent = ({ data, clinicVisitData }) => {
  return (
    <div className="d-flex" style={{ borderRadius: '4px', overflow: 'hidden', maxWidth: '400px' }}>
      <div
        style={{
          background: '#7838FF',
          color: '#fff',
          padding: '4px',
          flex: '1 0 0',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <div>Your Token</div>
        <div>{data?.appointmentNumber || '--'}</div>
      </div>
      <div
        style={{
          background: '#ECE0FF',
          color: '#B28CFF',
          padding: '4px',
          flex: '1 0 0',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <div>Current</div>
        <div>
          <FlashingTokenNumber>
            {clinicVisitData?.mentorCurrentTokenMap?.[data?.mentorId] || '--'}
          </FlashingTokenNumber>
        </div>
      </div>
    </div>
  )
}

//
//
//
//
//
//
//

export const PatientHomepagePrescriptionsSection = () => {
  return <PatientHomepageSectionContainer>My Prescriptions</PatientHomepageSectionContainer>
}

//
//
//
//
//
//
//

export const PatientHomepageMyClinicsSection = () => {
  return <PatientHomepageSectionContainer>My Clinic</PatientHomepageSectionContainer>
}

//
//
//
//
//
//
//

export const PatientHomepageBookTherapySection = () => {
  return <PatientHomepageSectionContainer>Book Therapy</PatientHomepageSectionContainer>
}

//
//
//
//
//
//
//

export const PatientHomepageInvestigationsSection = () => {
  return <PatientHomepageSectionContainer>My Investigation Reports</PatientHomepageSectionContainer>
}

//
//
//
//
//
//
//

export const PatientHomepageAllBookingsSection = () => {
  return <PatientHomepageSectionContainer>All Bookings</PatientHomepageSectionContainer>
}

//
//
//
//
//
//
//

export const PatientHomepageExploreWellnessSection = ({ chosenPatientId }) => {
  const { profileData, setProfileData } = useContext(ProfileContext)
  const { setupLoading, setupData, setupError } = useContext(SetupContext)
  const navigate = useNavigate()

  function handleClick() {
    if (profileData && !profileData?.info?.USER_ON_BOARD) {
      navigate('/onboarding', {})
    } else {
      const defaultTab = getTabOrder(setupData)?.preselectedTab
      navigate(`/tile/${defaultTab}`)
    }
  }

  return (
    <PatientHomepageSectionContainer>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ cursor: 'pointer' }}
        onClick={handleClick}
      >
        <div>
          <PHHeading>Explore</PHHeading>
          <PHHeading big>AUMHUM Wellness</PHHeading>
        </div>
        <div>
          <ExploreIcon style={{ fontSize: '40px' }} />
        </div>
      </div>
    </PatientHomepageSectionContainer>
  )
}

function getClinicBrandNameFromClinicBrandId(clinicBrandId, clinicBrandList) {
  const foundBrand = clinicBrandList?.find((item) => item?.id === clinicBrandId)
  if (foundBrand) {
    return foundBrand?.title || foundBrand?.name || ''
  }
  return ''
}
